'use client';

import Image from 'next/image';

interface City {
  name: string;
  imageUrl: string;
  alt: string;
}

const cities: City[] = [
{
  name: 'Chula Vista',
  imageUrl: "https://images.unsplash.com/photo-1619589104963-f4b96ac8fef3",
  alt: 'Chula Vista cityscape with palm trees and blue sky in San Diego County'
},
{
  name: 'Coronado',
  imageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_11812b554-1783656529254.png",
  alt: 'Coronado Island beach with the iconic Hotel del Coronado and Pacific Ocean'
},
{
  name: 'Del Mar',
  imageUrl: "https://images.unsplash.com/photo-1683994016240-493d9540f17d",
  alt: 'Del Mar coastal beach with golden sand and waves along the California coast'
},
{
  name: 'El Cajon',
  imageUrl: "https://images.unsplash.com/photo-1699135875655-37d6dbe5d0a6",
  alt: 'El Cajon suburban neighborhood with mountains in the background in East San Diego'
},
{
  name: 'La Jolla',
  imageUrl: "https://images.unsplash.com/photo-1631949465296-9db0d26e34d6",
  alt: 'La Jolla Cove with turquoise water, rocky cliffs and sea lions along the San Diego coast'
},
{
  name: 'La Mesa',
  imageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1446614a2-1783656528520.png",
  alt: 'La Mesa village street with shops and sunny California weather in East San Diego'
},
{
  name: 'Lemon Grove',
  imageUrl: "https://images.unsplash.com/photo-1657213039955-4c69e90be86a",
  alt: 'Lemon Grove neighborhood with lush green trees and residential streets in San Diego'
},
{
  name: 'National City',
  imageUrl: "https://images.unsplash.com/photo-1599474462637-eeedfe72b12f",
  alt: 'National City urban skyline with streets and buildings near San Diego Bay'
},
{
  name: 'Poway',
  imageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1e2cf0f17-1783656529290.png",
  alt: 'Poway scenic hills and open space with California chaparral landscape in North San Diego'
},
{
  name: 'San Diego',
  imageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_122dbc5c2-1773169887886.png",
  alt: 'San Diego downtown skyline with Coronado Bridge and San Diego Bay at sunset'
}];


export default function AreaCoverage() {
  return (
    <section className="bg-[#0f0f1a] py-16 px-4">
      <div className="max-w-6xl mx-auto text-center">
        {/* Heading */}
        <p className="text-accent text-sm font-semibold uppercase tracking-widest mb-3">
          Service Area
        </p>
        <h2 className="text-white text-2xl md:text-3xl font-bold mb-2">
          Proudly serving these cities &amp; surrounding areas in San Diego
        </h2>
        <div className="w-16 h-1 bg-accent rounded-full mx-auto mt-4 mb-12" />

        {/* City Cards Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {cities.map((city) =>
          <div
            key={city.name}
            className="group relative overflow-hidden rounded-xl border border-white/10 hover:border-accent/50 transition-all duration-300 cursor-default">
            
              {/* Image */}
              <div className="relative h-32 w-full overflow-hidden">
                <Image
                src={city.imageUrl}
                alt={city.alt}
                fill
                className="object-cover transition-transform duration-500 group-hover:scale-110"
                sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 20vw" />
              
                {/* Dark overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
              </div>

              {/* City Name */}
              <div className="absolute bottom-0 left-0 right-0 p-3 flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-accent flex-shrink-0" />
                <span className="text-white text-xs font-semibold leading-tight">
                  {city.name}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

}